import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    Select,
    Modal,
    Checkbox,
    Row,
    Col
} from "antd";
import Button from "antd-button-color";

import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { addUser, resetpassword, getRegion, getTerritory } from "./service";
// import { getTerritory } from "./../../service";
import _ from "lodash";

const { Option } = Select;
const { confirm } = Modal;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 16 },
        lg: { span: 14 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0
        },
        sm: {
            span: 16,
            offset: 8
        }
    }
};

function success() {
    let secondsToGo = 3;
    const onOkModal = () => {
        window.location.reload();
    }
    const modal = Modal.success({
        title: 'แก้ไขข้อมูล เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.reload();
    }, secondsToGo * 1000);
}
function error(message) {
    let secondsToGo = 3;
    const onOkModal = () => {
        modal.destroy();
    }
    const modal = Modal.warning({
        title: "Error: " + message,
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
    }, secondsToGo * 1000);
}

const Editform = (props) => {
    const [form, setFrom] = Form.useForm();

    const [load, setLoad] = useState(true)

    const [URID, setURID] = useState()

    const [territory_desc, setTerritory_desc] = useState([])
    const [territory_desc_text, setTerritory_desc_text] = useState()
    const [territory_tID, setTerritory_tID] = useState([])
    const [region_select, setRegion_select] = useState()
    const [territory_select, setTerritory_select] = useState()

    const [role_desc, setRole_desc] = useState()
    const [rID, setRID] = useState()
    const [tID, setTID] = useState([])

    const [dataRegion, setDataRegion] = useState([])
    const [dataTerritory, setTerritory] = useState([])

    useEffect(() => {
        var region_select_s = props.userDetail.territory_tID
        var chk_mix = []
        region_select_s.map((data, index) => {
            chk_mix.push(Number(data.substring(0, 3)))
        })
        var groupped = _.groupBy(chk_mix, function (n) { return n });
        var result = _.uniq(_.flatten(_.filter(groupped, function (n) { return n.length > 0 })));
        var rs = []
        if (result.length > 1) {
            rs = 311
        } else {
            rs = result
        }
        setRegion_select(rs)
        setURID(props.userDetail.URID)
        setRole_desc(props.userDetail.role_desc)
        setTerritory_tID(props.userDetail.territory_tID)
        function setLoadEffect() {
            setLoad(false)
        }
        function getRegionDetail() {
            getData();
        }
        function getData() {
            getTerritory(rs).then(res => {
                if (res && res.status === 200) {
                    setTerritory(res.data)
                    setLoadEffect()
                }
            })
            getRegion().then(res => {
                if (res && res.status === 200) {
                    setDataRegion(res.data)
                }
            })
        }
        getRegionDetail();

    }, [props]);

    const selectRegion = (e, name) => {
        setRegion_select(e)
        function getData() {
            getTerritory(e).then(res => {
                if (res && res.status === 200) {
                    // console.log("res", res)
                    setTerritory(res.data)
                }
            })
        }
        getData();
    }

    const onChange = (checkedValues) => {
        setTerritory_select(checkedValues)
    }

    const optionRegion = (
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectRegion}
        >
            {
                dataRegion.map((data, index) => {
                    // console.log("dataRegion", dataRegion)
                    return (
                        <Option key={index} value={data.rID} regionname={data.region}>{data.region}</Option>
                    );
                })
            }
        </Select>
    )

    const optionTerritory = (
        // <Checkbox.Group style={{ width: '100%' }} defaultValue={territory_tID} onChange={onChange}>
        <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
            <Row>
                {dataTerritory.map((data, index) => {
                    return (
                        <Col span={8} key={index}>
                            <Checkbox value={data.tID}>{data.territory}</Checkbox>
                        </Col>
                    );
                })}
            </Row>
        </Checkbox.Group>
    )

    const onFinish = (values) => {
        const formData = new FormData();
        formData.append('state', 'update');
        formData.append('URID', URID);
        formData.append('role_desc', values.roledesc);
        formData.append('rID', values.region);
        values.territory.forEach((item, index) => {
            formData.append(`tID[${index}]`, item);
        });

        addUser(formData).then(res => {
            if (res && res.status === 200) {
                form.resetFields();
                success()
            } else {
                error(res)
            }
        })
    };

    if (load) {
        return (
            <div>
                loading
            </div>
        );
    } else {
        return (
            <div >
                <Form
                    {...formItemLayout}
                    form={form}
                    name="editStaff"
                    id="editStaff"
                    onFinish={onFinish}
                    initialValues={{
                        roledesc: role_desc,
                        region: region_select,
                        territory: territory_tID
                    }}
                    scrollToFirstError
                >
                    <Form.Item
                        name="roledesc"
                        label="ชื่อกลุ่มผู้ใช้งาน"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาระบุ ชื่อกลุ่มผู้ใช้งาน!",
                            }
                        ]}
                    >
                        {/* <Input disabled={userLevel == 99 ? false:true} /> */}
                        <Input disabled={false} />
                    </Form.Item>

                    <Form.Item
                        name="region"
                        label="พื้นที่รับผิดชอบ"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาเลือก พื้นที่รับผิดชอบ!",
                            }
                        ]}
                    >
                        {optionRegion}
                    </Form.Item>
                    <Form.Item
                        name="territory"
                        label="เขตการขาย"
                        rules={[
                            {
                                required: true,
                                message: "กรุณาเลือก เขตการขาย!",
                            }
                        ]}
                    >
                        {optionTerritory}
                    </Form.Item>
                    <div style={{ paddingBottom: '10%' }}>
                        {/* <Button type="warning" onClick={resetPass} style={{ float: 'left' }}>
                            รีเซ็ตรหัสผ่าน
                        </Button> */}
                        <Button type="primary" htmlType="submit" style={{ float: 'right' }}>
                            แก้ไขข้อมูล
                        </Button>
                    </div >
                </Form>
            </div >
        );
    }

};

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default Editform